import React from 'react';
import "./App.css";
import { useNavigate } from 'react-router-dom';

import logoECJ from "./img/ecj-logo.svg";

export default function PagoPending() {
  sessionStorage.clear();
  
  const navigate = useNavigate();
  const btnBackToHome = () => {
    navigate('/');
  };

  return (
    <div className='thanks'>
      <img
        className='logoECJ'
        src={logoECJ}
        alt="EconoJournal"
      />
      <h2>Estamos procesando tu pago</h2>
      <h4>Tu pago está pendiente. Te avisaremos por mail cuando se apruebe.</h4>
      <button onClick={btnBackToHome}>Volver al inicio</button>
    </div>
  );
}
